import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import * as moment from "moment";

@Component({
	selector: "app-ms-visitor-log",
	templateUrl: "./ms-visitor-log.component.html",
	styleUrls: ["./ms-visitor-log.component.css"],
})
export class MsVisitorLogComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		FacilityID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		VisitorPassDetailStatusID: 0,
		VisitorTypeID: 0,
		VisitorStatusID: 0,
		SortBy: "LogDT",
		SortDirection: "DESC",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	FacilityList: any = [];
	VisitorPassDetailStatusList: any = [];
	VisitorTypeList: any = [];
	VisitorStatusList: any = [];
	ImageLogoList: any = [];

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	SortByList: any = [
		{
			ID: "LogDT",
			Desc: "Date/Time",
		},
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "ScanType",
			Desc: "Scan Type",
		},
		{
			ID: "Type",
			Desc: "Visitor Type",
		},
		{
			ID: "Status",
			Desc: "Visitor Status",
		},
		{
			ID: "Location",
			Desc: "Location",
		},
		{
			ID: "Facility",
			Desc: "Facility",
		},
		{
			ID: "Destination",
			Desc: "Destination",
		},
		{
			ID: "Comments",
			Desc: "Comments",
		},
	];
	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 447;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.user = this.userService.getCurrentUser();

		this.loadScanType();
		this.loadVisitorTypeList();
		this.loadVisitorStatusList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadFacilityList();
		this.loadLogolist();
	}

	private loadScanType() {
		var result = this.reportService.MsVisitorPassDetailStatusSelectList();
		result.subscribe(
			(response) => {
				this.VisitorPassDetailStatusList = response;

				this.VisitorPassDetailStatusList.unshift({
					VisitorPassDetailStatusID: -1,
					VisitorPassDetailStatusDesc: "Any",
					IsOnSite: true,
				});

				this.report.VisitorPassDetailStatusID = this.VisitorPassDetailStatusList[0].VisitorPassDetailStatusID;
			},
			(error) => {}
		);
	}

	private loadVisitorTypeList() {
		var result = this.reportService.MsVisitorTypeSelectList();
		result.subscribe(
			(response) => {
				this.VisitorTypeList = response;

				this.VisitorTypeList.unshift({
					VisitorTypeID: -1,
					VisitorTypeDesc: "Any",
				});

				this.report.VisitorTypeID = this.VisitorTypeList[0].VisitorTypeID;
			},
			(error) => {}
		);
	}

	private loadVisitorStatusList() {
		var result = this.reportService.MsVisitorStatusSelectList();
		result.subscribe(
			(response) => {
				this.VisitorStatusList = response;

				this.VisitorStatusList.unshift({
					VisitorStatusID: -1,
					VisitorStatusDesc: "Any",
				});

				this.report.VisitorStatusID = this.VisitorStatusList[0].VisitorStatusID;
			},
			(error) => {}
		);
	}

	private loadFacilityList() {
		var result = this.reportService.FacilitySelectList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.FacilityList = response;

				if (this.report.SchoolID <= 0) {
					this.FacilityList.unshift({
						FacilityID: -1,
						FacilityName: "All",
					});
				}

				this.report.FacilityID = this.FacilityList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 447;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: FacilityID
		strParam += "," + this.report.FacilityID + "|FacilityID";

		//Parameter 3: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 4: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 5: VisitorTypeID
		strParam += "," + this.report.VisitorTypeID + "|VisitorTypeID";

		//Parameter 6: VisitorStatusID
		strParam += "," + this.report.VisitorStatusID + "|VisitorStatusID";

		//Parameter 7: VisitorPassDetailStatusID
		strParam += "," + this.report.VisitorPassDetailStatusID + "|VisitorPassDetailStatusID";

		//Parameter 8: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 9: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 10: UserID
		strParam += "," + this.user.userID + "|UserID";

		//Parameter 11: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
